import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ItemToReturn } from '../../models/returns';
import { DisabledItem } from './DisabledItem';

interface SelectIneligibleItemsProps {
  ineligibleItems: ItemToReturn[];
}

const SelectIneligibleItems = ({
  ineligibleItems,
}: SelectIneligibleItemsProps) => {
  if (ineligibleItems.length === 0) return null;
  return (
    <div className="sui-mt-[48px] sui-mb-8">
      <Typography weight="bold" variant="body-lg">
        Items not eligible for return
      </Typography>
      {ineligibleItems?.map((item: ItemToReturn, index: number) => (
        <div key={item.lineItemId} className="sui-mb-6">
          <DisabledItem item={item} />
          {index !== ineligibleItems.length - 1 && (
            <hr className="sui-hidden md:sui-block" />
          )}
        </div>
      ))}
    </div>
  );
};

export default SelectIneligibleItems;
